import { Configuration } from "../../../configuration";

/** Configuration keys for deployment features, independent of user permissions. */
export const FEATURE_FLAG = {
    TLS_DISCOVERY: "allowTlsDiscovery",
} as const;

export type FeatureFlag = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];

/** Whether each feature is enabled for this deployment. */
export type FeatureFlags = Record<FeatureFlag, boolean>;

/** Reads feature flags from deployment configuration. */
export function getFeatureFlags(configuration: Pick<Configuration, FeatureFlag>): FeatureFlags {
    return {
        [FEATURE_FLAG.TLS_DISCOVERY]: configuration[FEATURE_FLAG.TLS_DISCOVERY],
    };
}
